(() => {
  'use strict';

  const envelopeMarkup = `
    <svg class="ra-premium-icon ra-premium-icon--envelope" viewBox="0 0 32 32" fill="none" aria-hidden="true" focusable="false">
      <rect x="4.25" y="6.75" width="23.5" height="18.5" rx="4.1" stroke="currentColor" stroke-width="1.55"></rect>
      <path d="M6.7 9.2L14.15 15.35C15.22 16.23 16.78 16.23 17.85 15.35L25.3 9.2" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M7.35 22.45L12.3 17.85M24.65 22.45L19.7 17.85" stroke="currentColor" stroke-width="1.15" stroke-linecap="round" opacity=".55"></path>
    </svg>`;

  const upgrade = () => {
    document.querySelectorAll('.ra-message-trigger').forEach((trigger) => {
      trigger.classList.add('ra-premium-message');
      const svg = trigger.querySelector('svg');
      if (!svg || svg.classList.contains('ra-premium-icon--envelope')) return;
      svg.outerHTML = envelopeMarkup;
    });

    document.querySelectorAll('.ra-premium-wishlist .wishlist-total-count').forEach((count) => {
      const value = Number.parseInt(count.textContent || count.dataset.total || '0', 10);
      count.classList.toggle('ra-zero-count-hidden', !Number.isFinite(value) || value <= 0);
    });
  };

  const start = () => {
    upgrade();
    const observer = new MutationObserver(upgrade);
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();